import { cqFill } from 'container-query-polyfill/cqfill.min';

const supportsContainerQueries = 'container' in document.documentElement.style;
if (!supportsContainerQueries) {
  cqFill({
    ignoreInlineStyles: true,
    stylesheetWhiteList: ['admin', 'campaigns', 'directory'],
  });
}
